import { Component, OnInit, Input } from '@angular/core';
import { getTimelineEvent, makeMessage } from '../../utils/message-utils';
import { ActivatedRoute, Router} from '@angular/router';

const TYPING_INDICATOR_WINDOW = 2000; // 2 seconds

@Component({
  selector: 'mitter-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.css']
})
export class ChatInputComponent implements OnInit {
  @Input() channel: any;
  @Input() mitter: any;
  @Input() userRole: string;
  textPayload: string = '';
  channelId: string;
  isDoctor: boolean;
  isPrescription: boolean = false;
  lastTyped: number;
  userTypingToken: string;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.channelId = params['chatid'];
    });
    this.isDoctor = this.userRole === "DOCTOR";
  }

  openImageForm() {
    this.router.navigate(["/chats", this.channel.channelId, "imageform"]);
  }

  sendTextMessage(textPayload) {
    if (!textPayload) return;
    let userId = this.mitter.getUserId();
    // Make message object
    const sentTimeEvent = getTimelineEvent('mitter.mtet.SentTime', userId);
    const textMessage = makeMessage('Standard', 'mitter.mt.Text', userId, textPayload, [sentTimeEvent]);
    if (this.isPrescription) {
      textMessage['messageData'] = [{
        dataType: 'petcart.messageInfo',
        data: {
          isPrescription: true
        }
      }];
    }
    // send message and reset input field
    this.mitter.sendMessageAsync(this.channel.channelId, textMessage)
      .then(() => this.textPayload = '');
  }

  handleKeyDown(event) {
    if (this.isPrintableKeyCode(event.keyCode)) {
      this.sendTypingIndictor();
    }

    if (event.keyCode == 13) {
      if (!event.shiftKey) {
        this.sendTextMessage(this.textPayload);
        event.preventDefault();
      }
    }
  }

  isPrintableKeyCode(keycode) {
    return (keycode > 47 && keycode < 58) || // number keys
        (keycode == 32 || keycode == 13)  || // spacebar & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91)    || // letter keys
        (keycode > 95 && keycode < 112)   || // numpad keys
        (keycode > 185 && keycode < 193)  || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223);   // [\]' (in order)
  }

  sendTypingIndictor() {
    // If last keyEvent was more than 3 seconds ago or this is the first keyEvent
    if (!this.lastTyped || (Date.now() - this.lastTyped > TYPING_INDICATOR_WINDOW)) {
      this.mitter.userIsTyping(this.channel.channelId);
      this.lastTyped = Date.now();
    }
  }

  togglePrescription() {
    this.isPrescription = !this.isPrescription;
  }
}
